module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox@2x-ca67bcb0f4c11e14dc0da23ce8dd70ae.png";